module.exports = __webpack_public_path__ + "static/img/v4_5.e5c257da.png";